import { Message } from "@angular/compiler/src/i18n/i18n_ast";
import { Component, AfterViewInit, OnInit, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ChangePasswordComponent } from "@app/auth/components/change-password/change-password.component";
import { TranslateService } from "@ngx-translate/core";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import { CommonService } from "@shared/services/common.service";
import storageService from "@shared/storage/storageService";
import { error } from "console";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  subscription: any;
  isComponent: any;
  default = "/assets/images/user.jpg";
  // default:any;
  sidenav_opened = true;
  firstName: any;
  lastName: any;
  selectedLanguage: any;
  currentUser: any = {};
  accountant:any;
  public isPopUpClosed: EventEmitter<boolean>;
  changePasswordPopUp: boolean;
  languages: any[] = [];
  dialogRef: any;
  clientId: any;
  accId: any;
  isSubmenuOpen: boolean = false;;
 

  constructor(
    private broadCast: BroadCastServiceService,
    private router: Router,
    public dialog: MatDialog,
    private apiCall: ApiCall,
    public commonService:CommonService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentUser = storageService.getItemAsJSON("currentUser");
    this.broadCast.getClientId().subscribe((message)=>{
      if(message){
        this.clientId = message;
      }
    })
    this.broadCast.getAccId().subscribe((message)=>{
      if(message){
        this.accId = message
      }
    })
    this.getAllLangues();
    this.isPopUpClosed = this.commonService.changePasswordEvent;
    this.isPopUpClosed.subscribe((state) => {
      this.changePasswordPopUp = state;
    });
    this.broadCast.childSubject.subscribe(data=>{
      this.accountant = data;
  })
    this.subscription = this.broadCast.getMessage().subscribe((message) => {
      if (message) {
        this.isComponent = message;
        if(this.isComponent  == 'Profile-Update'){
          this.getCurrentUserLoginDetails();
        }
      }
    });
    this.getCurrentUserLoginDetails();
    this.getOrganizationData();


  }
  
  toggleSubmenu() {
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }
  
  setDefaultLanguage() {
    try {
      if(this.currentUser?.id){
        this.apiCall.getSelectedLanguage(this.currentUser.id).subscribe(
          (response: any) => {
            this.selectedLanguage = this.languages.find((lang) => lang.shortName == response.data.shortName);
            this.translate.use(this.selectedLanguage.shortName);
            storageService.setItem("language", this.selectedLanguage.shortName);
          },
          (error) => {
            console.error("API error, ", error);
          }
        );
        
      }else{
        if(this.clientId){
          this.apiCall.getSelectedLanguage(this.clientId).subscribe((response : any)=>{
            this.selectedLanguage = this.languages.find((lang)=> lang.shortName == response.data.shortName);
            storageService.setItem("language", this.selectedLanguage.shortName)
          },
          (error)=>{
            console.error("API error, ", error)
          })
          
        }else{
         this.apiCall.getSelectedLanguage(this.accId).subscribe((res : any)=> {
          this.selectedLanguage= this.languages.find((lang)=> lang.shortName == res.data.shortName);
          storageService.setItem("language",this.selectedLanguage.shortName)
         },(error)=>{
          console.error("API error," , error)
         })
        }

      }
    } catch (error) {
      console.error("Error while setting default language, ", error);
    }
  }

  onLanguageChange() {
    try {
      if(this.currentUser.id){
        if (this.selectedLanguage) {
          this.apiCall.setLanguage(this.currentUser.id, this.selectedLanguage.shortName).subscribe(
            (response) => {
              this.translate.use(this.selectedLanguage.shortName);
              storageService.setItem("language", this.selectedLanguage.shortName);
              this.commonService.sendSetLanguageEvent();
            },
            (error) => {
              console.error("API error while setting the language, ", error);
            }
          );
        }

      }else{
        if(this.selectedLanguage){
          this.apiCall.setLanguage(this.clientId, this.selectedLanguage.shortName).subscribe(
            (response)=>{
              this.translate.use(this.selectedLanguage.shortName);
              storageService.setItem("language", this.selectedLanguage.shortName);
              this.commonService.sendSetLanguageEvent();
            },
            (error)=>{
              console.error("API error while setting the language, ", error);

            }
            )

        }
  }
    } catch (error) {
      console.error("Error while changing the language, ", error);
    }
  }

  getAllLangues() {
    try {
      this.apiCall.getAllLanguages().subscribe(
        (response: any) => {
          this.languages = response.data;
          this.setDefaultLanguage();
        },
        (error) => {
          console.error("API error => ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting languages, ", error);
    }
  }

  ngDoCheck() {
    if (this.sidenav_opened === true) {
      let innerFooter = document.getElementById("inner-footer");
      if (innerFooter) {
        innerFooter.classList.add("footer-pad");
      }
    } else {
      let innerFooter = document.getElementById("inner-footer");
      if (innerFooter) {
        innerFooter.classList.remove("footer-pad");
      }
    }
  }
  getCurrentUserLoginDetails() {
    if (storageService.getItem("currentUser") !== null) {
      this.currentUser = storageService.getItemAsJSON("currentUser");
      this.firstName = this.currentUser?.firstName;
      this.lastName = this.currentUser?.lastName;
      storageService.setItem("userId", this.currentUser?.id);
      if (this.currentUser?.imageUrl && this.currentUser) {
        this.default = this.currentUser?.imageUrl;
      }
    }
  }

  logout() {
    try {
      this.clearAllCatche();
      this.router.navigate(["/landing-page"]);
    } catch (error) {
      console.error("Error while logging out, ", error);
    }
  }

  openChangePwdModel() {
    let ref = this.dialog.open(ChangePasswordComponent);
    ref.afterClosed().subscribe((result) => {
      this.changePasswordPopUp = false;
    });
    this.changePasswordPopUp = true;
  }

  onLogoClick(){
    if(this.isComponent == 'client-profile'){
      this.router.navigate(["assign-accountants"]);
    }
    if(this.isComponent == 'chief-account' || this.isComponent == 'outlook-data-display-ca') {
      this.router.navigate(["/chiefaccountant/dashboard"]);
    }
    if(this.isComponent == 'organization') {
      this.router.navigate(["/superadmin/organization"]);
    }
    if(this.isComponent == 'accountant-dashboard' || this.isComponent == 'outlook-data-display') {
      this.router.navigate(["/accountant/my-appoinments"]);
    }
  }
  getRoute() {
    if(this.isComponent == 'client-profile' || this.isComponent == 'Assign-Accountants') {
      return 'client/profile';
    }
    if(this.isComponent == 'chief-account' || this.isComponent == 'outlook-data-display-ca') {
      return '/chiefaccountant/profile';
    }
    if(this.isComponent == 'accountant-dashboard' ||  this.isComponent == 'outlook-data-display' ) {
      return 'accountant/profile'
    }
    if(this.isComponent == 'organization') {
      return 'superadmin/profile'
    }
  }

  getOrganizationData(){
    if(this.currentUser?.organizationId){
      this.apiCall.fetchOrgById(this.currentUser.organizationId).subscribe((res) => {
        if(res.status){
          storageService.setItemAsJSON("currentUser", res.data);
        }
      })

    }
  }

  navigateTo(route: string) {
    this.router.navigateByUrl(route);
  }

  clearAllCatche(): void {
    localStorage.clear();
    sessionStorage.clear();

    // Clear Cookies
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    // Clear Cache Storage
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

  }
}
